import { ComponentProps } from "react";
import { RouteFactory } from "@app/routePaths";
import { BlockTitle } from "@blocks/Blocks";
import IndividualTrendingCard from "@features/pulse/components/trendingCards/IndividualTrendingCard";
import { useWindowSize } from "@hooks/useWindowSize";

type TrendingCardsProps = {
  /** The trending cards to be displayed. */
  trendingCards: ComponentProps<typeof IndividualTrendingCard>[];
  /** The current article id. */
  currentArticleId: string;
  /** The url path of the current article. */
  urlPath: string;
};

const TrendingCards = ({
  trendingCards,
  currentArticleId,
  urlPath,
}: TrendingCardsProps) => {
  const { isScreenXL } = useWindowSize();
  const dataSize = isScreenXL ? 6 : 4;

  const filteredTrendingCards = trendingCards
    .filter((trendingCard) => trendingCard.id !== currentArticleId)
    .slice(0, dataSize);

  const handleNavigateToPulse = () => {
    sessionStorage.setItem("pulse_back_path", urlPath);
  };

  return (
    <div
      className="mb-10 border-t border-black pt-3"
      data-testid="trending-cards-component"
    >
      <BlockTitle
        link={`${RouteFactory.pulse}?ref=trending-now`}
        text={"TRENDING NOW"}
        rootClassName="pb-3"
        rootLinkClassName="font-semibold font-poppins tracking-5% text-lg"
        onClick={handleNavigateToPulse}
        target="_self"
      />

      <div className="grid grid-cols-2 gap-4 pb-6 min-[720px]:grid-cols-4 xl:grid-cols-6">
        {filteredTrendingCards.map((trendingCard, index) => (
          <IndividualTrendingCard
            key={trendingCard.id}
            {...trendingCard}
            className={"w-full"}
            onClick={handleNavigateToPulse}
            linkParams={`trending-now-${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default TrendingCards;
